import { render, staticRenderFns } from "./emailDesign.vue?vue&type=template&id=2f5c97a5&scoped=true&"
import script from "./emailDesign.vue?vue&type=script&lang=js&"
export * from "./emailDesign.vue?vue&type=script&lang=js&"
import style0 from "./emailDesign.vue?vue&type=style&index=0&id=2f5c97a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c97a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VExpandXTransition,VIcon,VSheet})
